import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';
import CreateUserPopup from './CreateUserPopup';

import { updateVesselSizeUser } from 'actions/vessels/size';
import api from 'services';

class MainInfo extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            user: props.user.email,
            emails: [],
            isOpenAddUserPopup: false,
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.chooseEmail = this.chooseEmail.bind(this);
        this.openAddUserPopup = this.openAddUserPopup.bind(this);
        this.closeAddUserPopup = this.closeAddUserPopup.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            user: props.user.email || (this.props.letter.sender && this.props.letter.sender[0].address),
        });
    }

    changeEmail(searchText) {
        this.setState({
            user: searchText,
        }, () => {
            api.findUser(searchText)
                .then((response) => {
                    if (response.status === 200) {
                        const emails = response.data.data.map(item => ({
                            email: item.email,
                            item,
                        }));

                        this.setState({
                            emails,
                        }, () => {
                            const newUser = _.cloneDeep(this.props.user);
                            newUser.email = searchText;
                            this.props.updateVesselSizeUser(newUser);
                        });
                    }
                })
                .catch(() => {
                    return null;
                });
        });
    }


    chooseEmail(updateProperties) {
        const newUser = _.cloneDeep(this.props.user);
        newUser.email = updateProperties.item.email;
        this.props.updateVesselSizeUser(newUser);
    }

    openAddUserPopup() {
        this.setState({
            isOpenAddUserPopup: true,
        });
    }

    closeAddUserPopup() {
        this.setState({
            isOpenAddUserPopup: false,
        });
    }

    render() {
        const errorUser = this.props.errorUser ? this.props.errorUser.messages[0] : '';
        const { user, emails, isOpenAddUserPopup } = this.state;

        return (
            <div className='sidebar-table'>
                <CreateUserPopup
                    isOpen={isOpenAddUserPopup}
                    closeAddUserPopup={this.closeAddUserPopup}
                />
                <div className='title'>
                    CONTACTS
                </div>

                <div className='row half'>
                    <div className='column-left'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new user'
                            onClick={this.openAddUserPopup}
                            primary
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='column-left'>
                        User email
                    </div>
                    <div className='column-right'>
                        <AutoComplete
                            name='userEmail'
                            textFieldStyle={{ fontSize: '13px' }}
                            hintText='User email or id'
                            errorText={errorUser}
                            searchText={user}
                            dataSource={emails}
                            dataSourceConfig={{ text: 'email', value: 'item' }}
                            onUpdateInput={this.changeEmail}
                            onNewRequest={this.chooseEmail}
                            filter={AutoComplete.noFilter}
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        let errorUser = '';

        if (state.vesselSizes.items.length > 0) {
            errorUser = state.vesselSizes.items[0].validateErrors.find((validateError) => {
                return validateError.field === 'user';
            });
        }

        return {
            user: state.vesselSizes.user,
            errorUser,
            letter: state.letter,
        };
    },
    dispatch => bindActionCreators({
        updateVesselSizeUser,
    }, dispatch),
)(MainInfo);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/MainInfo.jsx